<template>
  <div class="data-list">
    <div class="head-box">
      <search-box class="search-box">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="80px" size="mini">
          <el-form-item label="经销商名称" prop="customerName">
            <el-input v-model="searchForm.customerName"></el-input>
          </el-form-item>
          <el-form-item label="核对结果" prop="res">
            <el-select v-model="searchForm.res" placeholder="请选择" @change="onSearch">
              <el-option label="全部" value=""> </el-option>
              <el-option label="正常" value="正常"> </el-option>
              <el-option label="异常" value="异常"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </div>
    <content-panel>
      <table-panel ref="tablePanel">
        <el-table stripe v-loading="loading" ref="tableRef" border highlight-current-row :data="tableData" :height="maxTableHeight">
          <el-table-column prop="customerName" label="经销商名称" align="center"></el-table-column>
          <el-table-column prop="settlementAmount" label="银联订单总金颔" width="180" align="center">
            <template slot="header">
              <el-tooltip class="item" effect="dark" content="不包含“已退款”并下单时间在今天00:00之前的所有订单的金额之和。" placement="top-start">
               <div> 
                <span>银联订单总金颔</span>
                <i class="el-icon-question"></i></div>
              </el-tooltip>
            </template>
            <template slot-scope="{ row }">
              <span class="number-box" @click="jumpDetail(row)">{{ row.settlementAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="waitVerifyAmount" label="待核销订单金额" align="center" width="170" show-overflow-tooltip>
            <template slot="header">
              <el-tooltip class="item" effect="dark" content='下单时间在今天00:00之前的所有“待核销"订单全额之和。' placement="top-start">
                <div> 
                  <span>待核销订单金额</span>
                  <i class="el-icon-question"></i>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="withdrawalBalance" label="待提现金额" align="center" width="140">
            <template slot="header">
              <el-tooltip class="item" effect="dark" content='包含银联冻结保证金' placement="top-start">
                <div> 
                  <span>待提现金额</span>
                  <i class="el-icon-question"></i>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="extractedCash" label="已提现金额" align="center" width="130">
          </el-table-column>
          <el-table-column prop="unionBalance" label="银联待划付金额" align="center" width="170">
            <template slot="header">
              <el-tooltip class="item" effect="dark" content=' 通过银联接口查询的待划分金额。' placement="top-start">
                <div> 
                  <span>银联待划付金额</span>
                  <i class="el-icon-question"></i>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="res" label="核对结果" align="center"  width="90"></el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
      <anew-check-dialog  
        :isShowAnewCheckDialog.sync="isShowAnewCheckDialog"
        @verifySuccess="onSearch"
      />
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import anewCheckDialog from "./anew-check-dialog";
export default {
  mixins: [tableMixin,pagePathMixin],
  components: {
    anewCheckDialog
  },
  data() {
    return {
      searchForm: {
        customerName: "",
        res: ""
      },

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      isShowAnewCheckDialog: false
    };
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport
        .checkCustomerUnionAmount(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    anewCheck() {
      this.isShowAnewCheckDialog = true
    },
    jumpDetail(row) {
      this.openSubPage({ path: "/dataReport/financial-data-details", query: {customerId: row.customerId} });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.data-list {
  .head-box {
    margin: 0 15px;
    padding: 10px;
    padding-top: 0;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    background: #fff;
  }
  .date-input  {
    width 220px !important
  }
  .number-box {
    color: #0bb78e;
    cursor: pointer;
  }
}
</style>
